/**
 * `<RankingProgressBanner>` — inline status banner shown above the table when
 * the JD's latest ranking run is queued or running. Read-only surface; the
 * actual Run-Ranking button lives on the Dashboard.
 *
 * Driven by the `useRankingRunByResource({ jdId })` query at the page level —
 * the page passes the boolean in. Design §1 (spec L627–644).
 */

interface Props {
  inFlight: boolean;
}

const SpinnerIcon = (): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className="h-4 w-4 animate-spin"
    aria-hidden
  >
    <path d="M12 3 a9 9 0 1 1 -9 9" strokeLinecap="round" />
  </svg>
);

export function RankingProgressBanner({ inFlight }: Props): JSX.Element | null {
  if (!inFlight) return null;
  return (
    <div
      data-testid="ranking-progress-banner"
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 rounded-md border border-accent-secondary/30 bg-surface-elevated px-3 py-2 text-sm font-medium text-text-primary"
    >
      <SpinnerIcon />
      Ranking in progress&hellip; results will appear here once complete.
    </div>
  );
}
